import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './styles/fonts.css'
import './styles/design.css'
import './styles/app.css'
import i18n, { languageFromPath, loadLanguage, type SupportedLanguage } from './i18n/i18n'
import { AuthProvider } from './auth/AuthContext'
import { initGtag } from './api/gtag'
import { initXPixel } from './api/xpixel'
import App from './App'

// Google Ads tag. No-ops until src/api/gtag.ts is configured; loaded here
// rather than at conversion time so it can read gclid off the landing URL.
initGtag()
// X Ads pixel for TOKEN2049 (+ ongoing). Same deferral story as gtag.
initXPixel()

function mount() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>,
  )
}

// English is bundled, so the common path mounts synchronously with no extra
// round trip. The other seven languages live in their own chunk and must
// land before the first render, otherwise the page paints in English and
// then swaps — worse than waiting a beat.
const boot = languageFromPath(window.location.pathname) as SupportedLanguage
if (boot === 'en') {
  mount()
} else {
  // Bounded wait. Holding the mount gives a flash-free first paint in the
  // right language, but one stalled chunk request must never mean a white
  // screen — so after 2.5s we mount anyway (i18next falls back to English)
  // and swap the language in when the translations do arrive.
  let mounted = false
  const mountOnce = () => {
    if (!mounted) {
      mounted = true
      mount()
    }
  }
  const bailOut = setTimeout(mountOnce, 2500)
  void loadLanguage(boot).finally(() => {
    clearTimeout(bailOut)
    void i18n.changeLanguage(boot)
    mountOnce()
  })
}